// extracted by mini-css-extract-plugin
export var locationCard = "_qd-0";